import { render, staticRenderFns } from "./contractor-info.vue?vue&type=template&id=6001c4d8&"
import script from "./contractor-info.vue?vue&type=script&lang=js&"
export * from "./contractor-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports